<script setup lang="ts">
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3';
import { ref, watch } from 'vue';

import CodeSnippet from '../codesnippet/CodeSnippet.vue';

// eslint-disable-next-line vue/define-props-declaration
const props = defineProps(nodeViewProps);
const code = ref(props.node.attrs.code);

watch(code, () => {
  props.updateAttributes({ code: code.value });
});
</script>

<template>
  <NodeViewWrapper>
    <CodeSnippet
      v-model:code="code"
      :readonly="!props.editor.isEditable"
      placeholder="Masukan Code"
    />
  </NodeViewWrapper>
</template>
